import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

class StaffOjtModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      aircraft_models: [],
      aircraft_model_subtypes: [],
      staff_ojt_manufacturers: [],
      staff_ojt_items: [],
      add_message: 0,
      id: '',
      ojt: '',
      date_start_str: '',
      date_finish_str: '',
      runs: '',
      trained_role: '',
      reference: '',
      type: '',
      service_order: '',
      rta: '',
      report: '',
      base: '',
      examiner: '',
      result: '',
      observations: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.export = this.export.bind(this);

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_staff_ojt.id !== 'undefined') {
        this.setState({
          id: newProps.data_staff_ojt.id,
          date_start_str: newProps.data_staff_ojt.date_start_str,
          date_finish_str: newProps.data_staff_ojt.date_finish_str,
          runs: newProps.data_staff_ojt.runs,
          trained_role: newProps.data_staff_ojt.trained_role,
          reference: newProps.data_staff_ojt.reference,
          type: newProps.data_staff_ojt.type,
          service_order: newProps.data_staff_ojt.service_order,
          rta: newProps.data_staff_ojt.rta,
          report: newProps.data_staff_ojt.report,
          base: newProps.data_staff_ojt.base_name,
          report: newProps.data_staff_ojt.report,
          result: newProps.data_staff_ojt.result,
          observations: newProps.data_staff_ojt.observations,
          aircraft_models: newProps.staff_ojt_aircraft_models,
          aircraft_model_subtypes: newProps.staff_ojt_aircraft_model_subtypes,
          staff_ojt_manufacturers: newProps.staff_ojt_manufacturers,
          staff_ojt_items: newProps.staff_ojt_items,
          add_message: newProps.add_message,
          ojt: newProps.data_staff_ojt.ojt_name,
        });
      }
      if (newProps.examiner) {
        if(typeof newProps.examiner.id !== 'undefined') {
          this.setState({
            examiner: newProps.examiner.name,
          });
        }    
      }
    }
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">OJT</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            {(self.state.add_message === 1) ? 
              <p className="bg-success" style={{padding: '15px 25px'}}><i className="fa fa-fw fa-fw fa-check"></i> Seu OJT foi cadastrado com sucesso! Uma cópia do formulário preenchido foi enviado ao seu e-mail e ao e-mail do examinador.</p> 
            : ''}
            <button className="btn btn-lg btn-success btn-block" onClick={() => { self.export('/exportar/colaborador/ojt/' + self.state.id) }}><i className="fa fa-fw fa-file-pdf-o"></i> EXPORTAR OJT</button>
            <hr/>
            <div className="row">
              <div className="col-md-4">
                <label>Tarefa:</label>
                <p>{self.state.ojt}</p>
                <br/>
                <label>Data de início:</label>
                <p>{self.state.date_start_str}</p>
                <br/>
                <label>Data de fim:</label>
                <p>{self.state.date_finish_str}</p>
                <br/>
                <label>Execuções:</label>
                <p>{self.state.runs}</p>
                <br/>
                <label>Função treinada:</label>
                <p>{self.state.trained_role}</p>
              </div>
              <div className="col-md-4">
                <label>Referência técnica:</label>
                <p>{self.state.reference}</p>
                <br/>
                <label>Tipo:</label>
                <p>{self.state.type}</p>
                <br/>
                <label>Ordem de serviço:</label>
                <p>{self.state.service_order}</p>
                <br/>
                <label>RTA:</label>
                <p>{self.state.rta}</p>
                <br/>
                <label>Relatório:</label>
                <p>{self.state.report}</p>
              </div>
              <div className="col-md-4">
                <label>Base:</label>
                <p>{self.state.base}</p>
                <br/>
                <label>Avaliador responsável:</label>
                <p>{self.state.examiner}</p>
                <br/>
                <label>Satisfatório:</label>
                <p>{self.state.result}</p>
                <br/>
                <label>Observações:</label>
                <p>{self.state.observations}</p>
              </div>
            </div>
            <hr/>
            <div className="row">
              <div className="col-md-3">
                <h4 className="page-title">Frotas</h4>
                <hr/>
                <table className="table table-hover tabled-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(self.state.aircraft_models).map(function(k) {
                      return (
                        <tr>
                          <td className="col-md-5">{self.state.aircraft_models[k].model}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="col-md-3">
                <h4 className="page-title">Motores</h4>
                <hr/>
                <table className="table table-hover tabled-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Motor</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(self.state.aircraft_model_subtypes).map(function(k) {
                      return (
                        <tr>
                          <td className="col-md-5">{self.state.aircraft_model_subtypes[k].motor}</td>
                          <td className="col-md-5">{self.state.aircraft_model_subtypes[k].name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="col-md-3">
                <h4 className="page-title">Fabricante</h4>
                <hr/>
                <table className="table table-hover tabled-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(self.state.staff_ojt_manufacturers).map(function(k) {
                      return (
                        <tr>
                          <td className="col-md-5">{self.state.staff_ojt_manufacturers[k].name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="col-md-3">
                <h4 className="page-title">Items</h4>
                <hr/>
                <table className="table table-hover tabled-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(self.state.staff_ojt_items).map(function(k) {
                      return (
                        <tr>
                          <td className="col-md-5">{self.state.staff_ojt_items[k].name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default StaffOjtModal;



// WEBPACK FOOTER //
// ./src/Components/StaffOjts/Elements/StaffOjtModal.js